import { Category } from "../types";
import floralImage from "../images/products/chanelGabrielle.jpg";
import orientalImage from "../images/products/chanelGabrielle.jpg";
import woodyImage from "../images/products/chanelGabrielle.jpg";
import freshImage from "../images/products/chanelGabrielle.jpg";
import gourmandImage from "../images/products/chanelGabrielle.jpg";
import aromaticImage from "../images/products/chanelGabrielle.jpg";
import { products } from "./products";

// Calculate product count for each category
const getProductCount = (categoryId: string) => {
  return products.filter(product => product.category === categoryId).length;
};

export const categories: Category[] = [
  {
    id: "floral",
    name: "Floral",
    image: floralImage,
    description: "Light and fresh fragrances with notes of rose, jasmine, and lily",
    productCount: getProductCount("floral"),
    discount: "Up to 25% OFF",
  },
  {
    id: "oriental",
    name: "Oriental",
    image: orientalImage,
    description: "Rich and exotic scents with amber, vanilla, and spices",
    productCount: getProductCount("oriental"),
    discount: "Up to 20% OFF",
  },
  {
    id: "woody",
    name: "Woody",
    image: woodyImage,
    description: "Warm and sophisticated fragrances with cedar, sandalwood, and patchouli",
    productCount: getProductCount("woody"),
    discount: "Up to 20% OFF",
  },
  {
    id: "fresh",
    name: "Fresh",
    image: freshImage,
    description: "Crisp and invigorating scents with citrus, herbs, and aquatic notes",
    productCount: getProductCount("fresh"),
    discount: "Up to 15% OFF",
  },
  {
    id: "gourmand",
    name: "Gourmand",
    image: gourmandImage,
    description: "Sweet and delectable fragrances with chocolate, coffee, and vanilla",
    productCount: getProductCount("gourmand"),
    discount: "Up to 15% OFF",
  },
  {
    id: "aromatic",
    name: "Aromatic",
    image: aromaticImage,
    description: "Herbal and refreshing scents with lavender, mint, and sage",
    productCount: getProductCount("aromatic"),
    discount: "Up to 20% OFF",
  },
];